var map = {
	"./aasimar.png": 8431,
	"./dragonborn.png": 205,
	"./dwarf.png": 2073,
	"./elf.png": 2626,
	"./gnome.png": 9865,
	"./goliath.png": 9501,
	"./halfling.png": 6146,
	"./human.png": 1806,
	"./orc.png": 571,
	"./tiefling.png": 5241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;